import { render } from "./NavbarComponent.vue?vue&type=template&id=39227ef6"
import script from "./NavbarComponent.vue?vue&type=script&lang=js"
export * from "./NavbarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rioschan/Downloads/event-2022kikkoman-main/vue-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__